import { Button } from '@mui/material';
import classNames from 'classnames';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import { useLoginService } from '../../../services/loginService/index';
import { forgotPasswordState } from '../../../services/loginService/store';
import rootStyles from '../index.module.scss';
import formStyles from '../LoginContent/index.module.scss';
import styles from './index.module.scss';

function PasswordIdentificationContent() {
  const {
    state,
    state: { errorMessage, forgotPassword },
  } = useLoginService();

  return (
    <div
      className={classNames(formStyles.root, rootStyles.boxContainer, 'w-full', {
        [rootStyles.hide]: forgotPassword.state !== forgotPasswordState.identification,
      })}
    >
      <div className={styles.content}>
        <span className={rootStyles.title}>Password reset requires identification.</span>
        <div
          className={classNames(
            'font-normal text-neutrals-n-400 text-center text-base w-full leading-snug ',
            formStyles.supportLink,
          )}
        >
          To reset your password, contact your account admin, or{' '}
          <a
            href="mailto:support@onestep.co"
            target="_blank"
            className="cursor-pointer hover:underline"
          >
            support@onestep.co
          </a>
        </div>
      </div>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        onClick={() => state.resetLoginStates()}
        className={clsx(formStyles.submitBtn, 'rounded-4')}
      >
        Continue
      </Button>
      {errorMessage ? <div className={formStyles.error}>{errorMessage}</div> : null}
    </div>
  );
}
export default observer(PasswordIdentificationContent);
